const ErrorStrings = {
  ERROR: 'Error',
  UNEXPECTED_ERROR: 'Ocurrió un error inesperado al conectarse al sistema. Por favor intentelo de nuevo más tarde.'
};

export default ErrorStrings;
